import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import commonEN from '@/locales/en/common.json'
import commonZhTW from '@/locales/zhTW/common.json'
import lightEN from '@/locales/en/light.json'
import lightZhTW from '@/locales/zhTW/light.json'
import menuEN from '@/locales/en/menu.json'
import menuZhTW from '@/locales/zhTW/menu.json'
import lightScheduleEN from '@/locales/en/lightSchedule.json'
import lightScheduleZhTW from '@/locales/zhTW/lightSchedule.json'
import lightGroupEN from '@/locales/en/lightGroup.json'
import lightGroupZhTW from '@/locales/zhTW/lightGroup.json'
import repairEN from '@/locales/en/repair.json'
import repairZhTW from '@/locales/zhTW/repair.json'
import userEN from '@/locales/en/user.json'
import userZhTW from '@/locales/zhTW/user.json'
import systemEN from '@/locales/en/system.json'
import systemZhTW from '@/locales/zhTW/system.json'
import dashboardEN from '@/locales/en/dashboard.json'
import dashboardZhTW from '@/locales/zhTW/dashboard.json'
import reportEN from '@/locales/en/report.json'
import reportZhTW from '@/locales/zhTW/report.json'
import sessionEN from '@/locales/en/session.json'
import sessionZhTW from '@/locales/zhTW/session.json'
import deviceEN from '@/locales/en/device.json'
import deviceZhTW from '@/locales/zhTW/device.json'
import cameraEN from '@/locales/en/camera.json'
import cameraZhTW from '@/locales/zhTW/camera.json'
import switchboxEN from '@/locales/en/switchbox.json'
import switchboxZhTW from '@/locales/zhTW/switchbox.json'
import visualdoorbellEN from '@/locales/en/visualdoorbell.json'
import visualdoorbellZhTW from '@/locales/zhTW/visualdoorbell.json'
import waterlevelEN from '@/locales/en/waterlevel.json'
import waterlevelZhTW from '@/locales/zhTW/waterlevel.json'

import mobileEN from '@/locales/en/mobile.json'
import mobileZhTW from '@/locales/zhTW/mobile.json'

// the translations
const resources = {
  en: {
    common: commonEN,
    menu: menuEN,
    light: lightEN,
    schedule: lightScheduleEN,
    lightGroup: lightGroupEN,
    repair: repairEN,
    user: userEN,
    system: systemEN,
    dashboard: dashboardEN,
    report: reportEN,
    mobile: mobileEN,
    session: sessionEN,
    device: deviceEN,
    camera: cameraEN,
    switchbox: switchboxEN,
    visualdoorbell: visualdoorbellEN,
    waterlevel: waterlevelEN,
  },
  'zh-TW': {
    menu: menuZhTW,
    common: commonZhTW,
    light: lightZhTW,
    schedule: lightScheduleZhTW,
    lightGroup: lightGroupZhTW,
    repair: repairZhTW,
    user: userZhTW,
    system: systemZhTW,
    dashboard: dashboardZhTW,
    report: reportZhTW,
    mobile: mobileZhTW,
    session: sessionZhTW,
    device: deviceZhTW,
    camera: cameraZhTW,
    switchbox: switchboxZhTW,
    visualdoorbell: visualdoorbellZhTW,
    waterlevel: waterlevelZhTW,
  },
}

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    ns: [
      'common',
      'light',
      'schedule',
      'lightGroup',
      'repair',
      'user',
      'system',
      'dashboard',
      'report',
      'mobile',
      'camera',
      'switchbox',
      'visualdoorbell',
    ],
    resources,
    lng: 'en',
    fallbackLng: 'en', // 可針對不同語系給予預設語系
    keySeparator: false, // we do not use keys in form messages.welcome
  })

export default i18n
